import { useParams } from 'react-router-dom';
import {useQuery} from "@tanstack/react-query";
import { fetchAccountRawData, fetchOmniStarAccount, fetchOmniStarAccountBalances } from '../../services';
import Allowances from './components/Allowances';
import TxSection from './components/TxSection';
import BalancesSection from './components/BalancesSection';
import { useContext } from 'react';
import { LabContext } from '../../context/lab';


const OmniAccount = () => {
  const {lab} = useContext(LabContext);
  const { address } = useParams();

  const { isLoading ,data, error, isFetching, isSuccess  } = useQuery(['balances-account', `${address}-nost`],  async () => 
      await fetchOmniStarAccountBalances({address: address!, denom: "nost", env: lab?.env}),
      {
        refetchOnWindowFocus: false, 
        retry: 3
      }
  );

  const { isLoading: AllowancesIsLoading ,data: AllowancesData, error: AllowancesError, isFetching: AllowancesIsFetching, isSuccess: AllowancesIsSuccess } = useQuery(['allowances', address],  async () => 
      await fetchOmniStarAccount({address: address!, env: lab?.env}),
      {
        enabled: !!data,
        refetchOnWindowFocus: false, 
        retry: 3
      }
  );    
  
  const { isLoading: creatorDataLoading ,data: creatorData, error: creatorDataError, isFetching: creatorDataFetching, isSuccess: creatorDataSuccess  } = useQuery(['creator-raw-data', address],  async () => 
      await fetchAccountRawData({address: address!, isCreator: true, env: lab?.env}),
      {
        enabled: !!data,
        refetchOnWindowFocus: false, 
        retry: 3
      }
  );
  
  const { isLoading: destDataLoading, data: destData, error: destDataError, isFetching: destDataFetching, isSuccess: destDataSuccess } = useQuery(['dest-raw-data', address],  async () => 
      await fetchAccountRawData({address: address!, isCreator: false, env: lab?.env}),
      {
        enabled: !!data,
        refetchOnWindowFocus: false, 
        retry: 3
      }
  );

  return (
    <div>
        { !!data
          ? <>
          <BalancesSection balances={[data]} error={error} isLoading={isLoading || isFetching} isSuccess={isSuccess} />
          <Allowances account={AllowancesData} error={AllowancesError} isLoading={AllowancesIsLoading || AllowancesIsFetching} isSuccess={AllowancesIsSuccess} />
          <TxSection 
            rawData={creatorData && destData ? [...creatorData.rawData, ...destData.rawData]: []} 
            error={creatorDataError || destDataError} 
            isLoading={creatorDataLoading || creatorDataFetching || destDataLoading || destDataFetching}
            isSuccess={creatorDataSuccess || destDataSuccess}
            address = {address || ""}
            />
          </>
          : <h4>Account: {address} was not found </h4>
        } 
    </div>
  )
}

export default OmniAccount;